import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { convertStraight } from "../../common-data/Converts";
// import AddButton from "../../payouts-wtf/common/AddButton";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { approveLeave } from "../../../data/ApiEndpoints";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";

const LeaveDates = ({
  userInfoData,
  leaveDetails,
  callFunction,
  rowData,
  closeModal,
  approvalManagerInfo,
}) => {
  const dispatch = useDispatch();
  const { isApprovalManager, approvalManagerFor } = approvalManagerInfo || {};
  const [selectedRows, setSelectedRows] = useState([]);

  const isAdmin = userInfoData?.account_type === "admin";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isClubManager = userInfoData?.is_club_manager;

  const isApManager =
    // Cluster managers and club managers can always approve/reject leaves
    isClusterManager || isClubManager
      ? true
      : // If admin and approval manager, allow approval
      isAdmin && isApprovalManager
      ? true
      : // If user is an approval manager, check their permissions
      isApprovalManager
      ? approvalManagerFor === "all" ||
        (rowData?.reporting_manager &&
          (rowData?.reporting_manager === userInfoData?.uid ||
            rowData?.reporting_manager === userInfoData?.user_id))
      : // Non-approval managers cannot approve/reject
        false;

  const isShowBtn =
    isApManager && leaveDetails?.length > 0
      ? leaveDetails.some((leave) => leave?.approval_status === 0)
      : false;

  const sortedLeaveDetails =
    leaveDetails?.length > 0
      ? [...leaveDetails].sort((a, b) => {
          const dateA = new Date(a.leave_date);
          const dateB = new Date(b.leave_date);
          return dateA - dateB;
        })
      : [];

  const handleCheckboxChange = (event, row) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setSelectedRows((prevRows) => [...prevRows, row]);
    } else {
      setSelectedRows((prevRows) =>
        prevRows.filter((selectedRow) => selectedRow.uid !== row.uid)
      );
    }
  };

  const handleApprove = async () => {
    const { gym_id, user_id, apply_date, leave_category_id } = rowData;

    const approvalUids = selectedRows.map((date) => date?.uid);

    const filter = {
      gym_id: gym_id,
      user_id: user_id,
      apply_date: apply_date,
      leave_category_id: leave_category_id,
      approval_dates_uids: JSON.stringify(approvalUids),
      aprv_rej_by: userInfoData?.uid || userInfoData?.user_id,
    };

    const method = "POST";
    const endpoint = approveLeave;
    const token = userInfoData?.token || "";
    const payload = filter;

    const handleConfirm = async () => {
      if (filter) {
        try {
          const response = await dispatch(
            commonPostPutApi({ method, endpoint, payload, token })
          ).unwrap();

          console.log(response);

          if (response?.status) {
            toast.success(response?.message || "Approved successfully!");
            callFunction();
            closeModal();
          } else {
            toast.error(response?.message || "Can not approve!");
          }
        } catch (error) {
          toast.error(error || "Failed to approve");
        }
      } else {
        toast.error("UID required!");
      }
    };

    showConfirmAlert(handleConfirm, `Are you sure, you want to approve these!`);
  };

  const getLeaveStatusInfo = () => {
    const pendingLeaves =
      leaveDetails?.filter((leave) => leave?.approval_status === 0) || [];
    const selectedLeaveIds = selectedRows.map((row) => row.uid);

    const selectedDates = pendingLeaves
      .filter((leave) => selectedLeaveIds.includes(leave.uid))
      .map((leave) => convertStraight(leave.leave_date));

    const unselectedDates = pendingLeaves
      .filter((leave) => !selectedLeaveIds.includes(leave.uid))
      .map((leave) => convertStraight(leave.leave_date));

    return { selectedDates, unselectedDates };
  };

  const { selectedDates, unselectedDates } = getLeaveStatusInfo();

  const leaveDetailsTbColumns = [
    {
      dataField: "select",
      text: "Select",
      formatter: (_, row) => {
        const isApprovalManagerId =
          isClusterManager || isClubManager
            ? true
            : isAdmin && isApprovalManager
            ? true
            : isApprovalManager
            ? approvalManagerFor === "all" ||
              rowData?.reporting_manager ===
                (userInfoData?.uid || userInfoData?.user_id)
            : false;

        const isDisbaled =
          row?.approval_status === 1 ||
          row?.approval_status === 2 ||
          !isApprovalManagerId
            ? true
            : false;

        return (
          <div
            className="tbDataFlexCenter checkbox-container"
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              columnGap: "5px",
            }}
          >
            <input
              type="checkbox"
              onChange={(event) => handleCheckboxChange(event, row)}
              checked={row.checked}
              disabled={isDisbaled}
            />

            {!isDisbaled ? (
              <small
                style={{
                  color: "#171717",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "capitalize",
                }}
              >
                Select To Approve
              </small>
            ) : null}
          </div>
        );
      },
    },
    {
      dataField: "apply_date",
      text: "Apply Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {rowData?.apply_date ? convertStraight(rowData.apply_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "leave_date",
      text: "Leave Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.leave_date ? convertStraight(row.leave_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "approval_status",
      text: "approval status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.approval_status === 1
                  ? "#DCECDC"
                  : row?.approval_status === 0
                  ? "#FFEDC0"
                  : "#F0E3E3",
              color:
                row?.approval_status === 1
                  ? "#209216"
                  : row?.approval_status === 0
                  ? "##171717"
                  : "#F13434",
            }}
          >
            {row?.approval_status === 1
              ? "Approved"
              : row?.approval_status === 0
              ? "Pending"
              : row?.approval_status === 2
              ? "Rejected"
              : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "aprv_rej_date",
      text: "Approve/Reject Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.aprv_rej_date ? convertStraight(row.aprv_rej_date) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      {isShowBtn ? (
        <div className="leave-approval-action-container">
          {(selectedDates.length > 0 || unselectedDates.length > 0) && (
            <div className="leave-status-info">
              <h4>Leave Action Summary</h4>

              {selectedDates.length > 0 && (
                <div className="status-section approve">
                  <h5>Dates to be Approved ({selectedDates.length})</h5>
                  <div className="date-list">
                    {selectedDates.map((date, index) => (
                      <span key={index} className="date-chip approve">
                        {date}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {unselectedDates.length > 0 && (
                <div className="status-section reject">
                  <h5>Dates to be Rejected ({unselectedDates.length})</h5>
                  <div className="date-list">
                    {unselectedDates.map((date, index) => (
                      <span key={index} className="date-chip reject">
                        {date}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="leave-action-buttons">
            {selectedRows?.length > 0 ? (
              <button className="leave-approve-btn" onClick={handleApprove}>
                Approve Selected ({selectedRows.length}) Date
                {selectedRows.length > 1 ? "s" : ""}
              </button>
            ) : (
              <button className="leave-reject-btn" onClick={handleApprove}>
                Reject All Leaves
              </button>
            )}
          </div>
        </div>
      ) : null}

      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile mt30">
        <PaymentLinkTable
          tableData={sortedLeaveDetails}
          tableColumns={leaveDetailsTbColumns}
        />
      </div>

      <div className="lead-logs-card-container leave-management-mobile-v only-mobile">
        <div className="all-leads-log mt30">
          {sortedLeaveDetails?.length > 0 &&
            sortedLeaveDetails.map((staff, index) => {
              const isDisbaled =
                staff?.approval_status === 1 || staff?.approval_status === 2
                  ? true
                  : false;

              return (
                <div className="log-card" key={index}>
                  <div className="all-info" style={{ padding: "20px" }}>
                    <div className="card-other-info checkbox-wrapper-container">
                      <div className="checkbox-container">
                        <input
                          type="checkbox"
                          onChange={(event) =>
                            handleCheckboxChange(event, staff)
                          }
                          checked={staff.checked}
                          disabled={isDisbaled}
                        />

                        <label htmlFor="checked" className="checkbox-label">
                          Select To Approve Leaves
                        </label>
                      </div>
                    </div>

                    <div className="lead-multi-value-cols">
                      <div className="label-value">
                        <span className="label">Leave Date</span>
                        <span className="value">
                          {staff?.leave_date
                            ? convertStraight(staff.leave_date)
                            : "-"}
                        </span>
                      </div>

                      <div className="label-value">
                        <span className="label">approval status</span>
                        <span
                          className="value"
                          style={{
                            background:
                              staff?.approval_status === 1
                                ? "#DCECDC"
                                : staff?.approval_status === 0
                                ? "#FFEDC0"
                                : "#F0E3E3",
                            color:
                              staff?.approval_status === 1
                                ? "#209216"
                                : staff?.approval_status === 0
                                ? "##171717"
                                : "#F13434",
                            padding: "5px",
                            borderRadius: "4px",
                          }}
                        >
                          {staff?.approval_status === 1
                            ? "Approved"
                            : staff?.approval_status === 0
                            ? "Pending"
                            : staff?.approval_status === 2
                            ? "Rejected"
                            : "NA"}
                        </span>
                      </div>

                      <div className="label-value flex-col">
                        <span className="label">Approve/Reject Date</span>
                        <span className="value">
                          {staff?.aprv_rej_date
                            ? convertStraight(staff.aprv_rej_date)
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default LeaveDates;
